module.exports = __webpack_public_path__ + "static/media/5_.294edf52.png";